import * as React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import { createRoot } from 'react-dom/client';
import Box from '@mui/material/Box';
import { v4 as uuidv4 } from 'uuid';

import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';

import {TabulatorFull as Tabulator} from "tabulator-tables"; //import Tabulator library
//import '../Bs4Theme/tabulator_scss/themes/tabulator_simple.scss';
import '../Bs4Theme/tabulator_scss/themes/tabulator_silent_bs4.scss';
//import cssTabulator from '../Bs4Theme/tabulator_scss/themes/tabulator_silent_bs4.scss';
//import "tabulator-tables/dist/css/tabulator_simple.min.css"; //import Tabulator stylesheet

import Bs4Kartoteka from '../Bs4Kartoteka'
import Bs4MainDispatch from '../Bs4MainDispatch';
import Bs4MainWindow from '../Bs4MainWindow';
import Bs4ReportTabulator from './Bs4ReportTabulator';
import { TYPE_BS4REPORTTABULATOR } from '../Bs4Theme/Bs4UxTemplateEditors/Bs4ReportTabulatorUx';
import Bs4Criteria from './Bs4Criteria';
import Bs4CriteriaSummary from './Bs4CriteriaSummary';
import Bs4GenericField from '../Bs4Form/Bs4Fields/Bs4GenericField';
import formFieldBinding from '../Bs4Form/Bs4FormFieldBinding';
import { useStateUxTemplate, SmallScreenContext } from '../Bs4Theme/Bs4UxTemplates';
import { HideOnScroll, useScrollTarget} from '../Bs4Components/HideOnScroll';
import { shallowEqual } from '../Bs4Components/Bs4Utils';

// "tabulator-tables": "^6.2.0",

export default class Bs4ReportType1 extends Bs4ReportTabulator {
  
  toArray = (object) => {
    if (Array.isArray(object)) return object;
    return [];
  }

  createModel() {
    super.createModel();

    this.rowActiveClick = String(this.getPageParam('row_active_click'));
    const bs4Kartoteka = Bs4Kartoteka.get(this.bs4KartotekaId);
    const bs4SourceKartoteka = Bs4Kartoteka.get(bs4Kartoteka.bs4SourceKartotekaId)
    if (bs4SourceKartoteka?.sourceField?.query?.startsWith('search_') && !this.targetField) {
      this.targetField = bs4SourceKartoteka.sourceField;
      const atr = this.toArray(this.targetField.field.props?.field?.atr).filter(atr => atr !== 'ATRYB_ONCHANGE') || [];
      atr.push('READONLY');
      // console.log('...atr.atr.atr...', atr)
      delete bs4SourceKartoteka.sourceField;
      this.targetField.newField = formFieldBinding({
        ...this.targetField.field.props,
        field: {
          ...this.targetField.field.props.field,
          atr: atr, // this.toArray(this.targetField.field.props?.field?.atr).filter(atr => atr !== 'ATRYB_ONCHANGE') || [],
          width: '100%',
        },
        bs4flexframe: false,
        width: '100%',
        noSearch: true,
      });
      
      this.targetField.newField.initializeFormField();
      this.targetField.newField.bs4Form = this.targetField.field.bs4Form;      
      this.targetField.newField.setValue(this.targetField.field.getValue());
    }
  }

  bs4Totals = null;

  getBs4Totals = () => {
    return this.bs4Totals;
  }

  setBs4Totals = function (bs4totalsStr, lastPage) {
    this.bs4Totals = null;
    if (bs4totalsStr) {
      try {      
        this.bs4Totals = JSON.parse(bs4totalsStr);
        this.bs4Totals.lastPage = lastPage;
      } catch(error) {
        this.bs4Totals = null;
      }
    }
  }
  
  footerElementOk1 = () => {
    const report = this;
    const editor = document.createElement('div');
    //editor.style.width = "300px";
    //editor.style.height = "160px";
    editor.innerHTML = 'innerHTML';  // Bez tego nie działa, tekst dowolny
    // ?!? editor.className = 'tabulator-footer';
    const root = createRoot(editor);
    root.render(<report.ViewBs4Footer/>);        
    return editor;
  }

  paginationElement = () => {
    const report = this;
    const editor = document.createElement('div');
    //editor.style.width = "300px";
    //editor.style.height = "160px";
    editor.innerHTML = 'innerHTML ?????????????';  // Bez tego nie działa, tekst dowolny
    // ?!? editor.className = 'tabulator-footer';
    //const root = createRoot(editor);
    //root.render(<report.ViewPagination/>);        
    return editor;
  }

  isSimple = () => this.props?.bs4Source === 'Bs4SipleGrid';

  /////////////////////////////////////////////////////////////////////////////////////
  //////////////////// Selection for select (KontrolkaWybor, WyborMultiple) ///////////
  /////////////////////////////////////////////////////////////////////////////////////

  selectable = "highlight";
  selectableCheckbox = false
  selesctedRowsId = new Set();
  selesctedLastRow = null;
  fieldOserverEnabled = false;
  shiftOserverEnabled = true;

  rowSelectedShift(row) {
    if (! this.shiftOserverEnabled || this.keyDown !== 'Shift') return;
    if (!this.selesctedLastRow || this.selectable === 1) return;    
    let minPosition = row.getPosition();
    let maxPosition = this.selesctedLastRow.getPosition();
    if (maxPosition < minPosition) {
      const position = maxPosition;
      maxPosition = minPosition;
      minPosition = position;
    }

    const rows = this.tabulator.getRows().filter((row) => {
      const position = row.getPosition();
      return position > minPosition && position < maxPosition;
    });    
    
    this.shiftOserverEnabled = false;
    this.tabulator.selectRow(rows.map(row => row.getData().id))
    //array.forEach(item => mySet.add(item))
    this.shiftOserverEnabled = true;
  }

  rowSelected(row) {    
    if (this.selectable === 1) this.selesctedRowsId.clear();    
    this.selesctedRowsId.add(row.getData().id);
    this.rowSelectedShift(row)
    if (this.shiftOserverEnabled) this.selesctedLastRow = row;
  }

  rowDeselected(row) {    
    this.selesctedRowsId.delete(row.getData().id);
    if (this.shiftOserverEnabled) this.selesctedLastRow = null;
  }

  clearSelected() {
    this.selesctedRowsId.clear();
    this.tabulator.deselectRow(this.tabulator.getSelectedData().map(row => row.id));
    if (this.shiftOserverEnabled) this.selesctedLastRow = null;
  }

  /////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////

  rowSelectionChanged(data, rows) {    
    // console.log('...???...Calk rowSelectionChanged')
    this.tabulator.recalc();
    if (this.fieldOserverEnabled && !this.dataProcessing) {    
      if (this.targetField?.query?.startsWith('search_')) {
        const promise = this.targetField.newField.setValueIds(Array.from(this.selesctedRowsId));
        if (promise) promise
        .then(isOk => {
          if (this.targetField?.query === 'search_single') this.targetField.handleActionsFooterOk()
        })
        .catch(error => {
          console.log(error);
        })
      }       
    }
  }

  bs4HandleChangePage(page) {
    if (this.isDirty()) {
      const bs4kartoteka = Bs4Kartoteka.get(this.bs4KartotekaId);
      bs4kartoteka.canClose()
      .then(msg => {
        this.clear();
        this.tabulator.setPage(page);
      })
      .catch(msg => {
        console.log(msg)
      })
    } else {
      this.tabulator.setPage(page);
    }
  }

  ajaxParams = () => {
    Bs4MainDispatch.speedRun((tag) => {
      console.log(Bs4MainDispatch.speedNextTime(tag), Bs4MainDispatch.speedBs4KarOpt(this.bs4KartotekaId, this.optionId))
    }, '..Type_1 ajaxParams..');
    return this.fetchCriteriaVals(this.tableBuilt);
  }

  ajaxURLGenerator = (url, config, params) => {
    // console.log('... ajaxURLGenerator ...', url, config, {...params}, this.props)
    params.page = params.page - 1; //serwer liczy od 0
    params.start = params.page * params.size;        
    if (this.tableBuilt) {
      const group = this.getGroupBy();
      if (group) {
        const property = group.getField();
        if (property) params.group = JSON.stringify({property: property, direction: 'ASC'});
        //console.log('...group...', group, params.group)
      }      
    }    

    try {            
      const sort = params.sort[0]      
      if (sort) {
        params.sort = sort.field;
        params.dir = (sort.dir || '').toUpperCase();
      }
    } catch(error) {
      console.log(error)
      delete params.sort;
      delete params.dir;
    }

    //console.log('... ajaxURLGenerator ...', url, params, config)    
    return url;
  }

  ajaxResponse = (url, params, response) => {    
    //return null;    
    Bs4MainDispatch.parsingBs4Response(response, this.bs4KartotekaId)
    if (response?.metaData?.addCounterToPage && response?.metaData?.counterString) {      
      const bs4Kartoteka = Bs4Kartoteka.get(this.bs4KartotekaId);
      if (bs4Kartoteka.updateDelayedTabsData) bs4Kartoteka.updateDelayedTabsData({_Komunikat: {[response.metaData.addCounterToPage] : response.metaData.counterString}})
    }
    if (!response.dane) {
      console.log('...Ajax Response...BRAK DANYCH.', params, response);
      return null;
    }
    const data = response.dane.map(record => {
      record.id = record.id || uuidv4();
      this.tabulatorLastRowData = record;      
      return record;
    })
    
    const lll = data.length;

    this.tabulatorLastRow = response.ilosc;
    this.tabulatorLastPage = Math.ceil(response.ilosc / params.size);
    this.setBs4Totals(response?.metaData?.bs4totals, this.tabulatorLastPage);
    const bs4Response = {
      data: data.slice(0, params.size),
      last_row: this.tabulatorLastRow, 
      last_page: this.tabulatorLastPage,
    }
    
    this.setBs4PageProps({
      ...this.bs4PageProps,
      counter: (this.bs4PageProps.counter || 0) + 1,
      currentPage: params.page, 
      lastRow: bs4Response.last_row,
      lastPage: bs4Response.last_page,
      inProgress: false,
    });

    // console.log('...Ajax Response....', params, this.bs4PageProps, response, bs4Response, this.props)

    if (this.props.setHideEmptyElm) this.props.setHideEmptyElm(data.length < 1);

    Bs4MainDispatch.speedRun((tag) => {
      console.log(Bs4MainDispatch.speedNextTime(tag), lll, Bs4MainDispatch.speedBs4KarOpt(this.bs4KartotekaId, this.optionId))
    }, '..Type_1 ajaxResponse..');
    
    return bs4Response;
  }

  rowMoved = (row) => {
    const before = 'before';
    const after = 'after';
    let sourceRowId = null;
    let dropPosition = after;
    let targetRowId = null;

    for (const rowAmong of this.tabulator.getRows()) {
      if (rowAmong.getData().id === row.getData().id) {
        sourceRowId = row.getData().id;
        continue;
      }

      targetRowId = targetRowId = rowAmong.getData().id;

      if (sourceRowId) {
        dropPosition = before;        
        break;
      }      
    }

    if (this.getPageParam('allowdragdrop')) {
      const details = {sourceRowId: sourceRowId, targetRowId: targetRowId, dropPosition: dropPosition, currFormId: this.formId}
      Bs4MainDispatch.commandParser('Bs4DragDrop', details, this.bs4KartotekaId);
    }
  }

  stylexx1 = {
    '.tabulator .tabulator-header .tabulator-row': {
      borderBottomColor: '#ff0000'
    }
  };

  stylexx = {
    //'.tabulator.tabulator-header': {
    '.xxxxxx': {
      color: '#ff0000',
      borderBottomColor: '#ff0000'
    }
  };
  
  isSearchSingle = () => this.targetField?.query === 'search_single' || this.rowActiveClick === '2';
  isSearchMultiple = () => this.targetField?.query === 'search_multiple' || this.rowActiveClick === '3';

  ViewSelectorField = (props) => {

    if (this.targetField?.query.startsWith('search_')) {   
      const targetField = this.targetField;
      return (
        <Stack direction='row' spacing={0} sx={{justifyContent: 'flex-start', alignItems: 'flex-start',}}>
          <targetField.newField.ViewComponent/>
        </Stack>
      )
    }
  }

  ViewSelectorActionsFooter = () => {      

    const handleActionsFooterOk = () => {   
      if (this.rowActiveClick === '3' && !this.targetField) {
        const rowObjectId = Array.from(this.selesctedRowsId);
        Bs4MainDispatch.commandParser('Bs4RowClick', { rowObjectId: rowObjectId, currFormId: this.formId }, this.bs4KartotekaId);
      }

      if (this.targetField?.query.startsWith('search_')) {
        this.targetField.newField.off(this.targetField.onChange);
        this.targetField.field.setValue(this.targetField.newField.getValue());
        
        Bs4Kartoteka.remove(this.bs4KartotekaId)
        .then(() => {
          Bs4MainWindow.showStack();
        });
      }            
    }

    const handleActionsFooterCancel = () => {
      if (this.targetField?.query.startsWith('search_')) {
        this.targetField.newField.off(this.targetField.onChange);
      }
      Bs4Kartoteka.remove(this.bs4KartotekaId)
      .then(() => {
        Bs4MainWindow.showStack();
      });
    }    
    
    if (this.isSearchSingle()) {
      if (this.targetField?.query === 'search_single') this.targetField.handleActionsFooterOk = handleActionsFooterOk;
      return (
        <Stack direction="row" justifyContent="flex-end" alignItems="center" spacing={1}>
          <Button startIcon={<CloseIcon/>} onClick={handleActionsFooterCancel}>Anuluj</Button>
        </Stack>
      )
    }

    if (this.isSearchMultiple()) {
      return (
        <Stack direction="row" justifyContent="flex-end" alignItems="center" spacing={1}>
          <Button startIcon={<DoneIcon/>} onClick={handleActionsFooterOk}>Ok</Button>
          <Button startIcon={<CloseIcon/>} onClick={handleActionsFooterCancel}>Anuluj</Button>
        </Stack>
      )
    }
  }

  ViewComponent = React.forwardRef((props, ref) => {
    const report = this;    
    const setScrollTarget = useScrollTarget(this.optionId, props.formField);

    return (
      <report.ViewComponentNext ret={ref} {...props} setScrollTarget={setScrollTarget} />
    )
  });

  ViewComponentNext = React.memo(React.forwardRef((props, ref) => {
    const report = this;    
    const theme = useTheme()
    const refTabulator = React.useRef();
    const [bs4PageProps, setBs4PageProps] = React.useState(this.bs4PageProps);    
    const {dateTimeStamp} = useStateUxTemplate(TYPE_BS4REPORTTABULATOR);
    const smallScreen = React.useContext(SmallScreenContext);
    const boxSx = React.useMemo(() => this.getBoxSxTabulator(theme, smallScreen), [dateTimeStamp, theme, smallScreen]);
    const [tabulator, setTabulator] = React.useState(null);
    const refPaginationElement = React.useRef(null);
    this.refTabulator = refTabulator;

    const refSpeedTest = React.useRef({
      shallowEqualValues: null,
      shallowEqualProps: null,
    });  

    if (!tabulator) {
      this.tableBuilt = false;
      this.tabulator = null;
    } 

    React.useEffect(() => {
      let tabulatorRect = null;
      if (!refTabulator.current) return;
      const resizeObserver = new ResizeObserver(() => {
        const rect = refTabulator.current.getBoundingClientRect();
        if (tabulatorRect?.width !== rect?.width) {
          setTimeout(() => {if (this.tabulator) this.tabulator.redraw();}, 300);
          tabulatorRect = rect;
        }
      });
      resizeObserver.observe(refTabulator.current);
      props.setScrollTarget(refTabulator.current?.children?.item(1));

      return () => resizeObserver.disconnect();
    }, [refTabulator.current]);

    React.useEffect(() => {
      if (this.tabulator && this.tableBuilt) this.tabulator.redraw(true);
    }, [dateTimeStamp]);

    React.useEffect(() => {
      Bs4MainDispatch.speedRun((tag) => {
        console.log(Bs4MainDispatch.speedNextTime(tag), Bs4MainDispatch.speedBs4KarOpt(this.bs4KartotekaId, this.optionId))
      }, '..Type_1 Eff..');
      this.selectable = "highlight";
      //this.selectableCheckbox = this.getPageParam('addcheckboxcolumn');
      this.selectableCheckbox = this.getSelectableCheckbox();
      if (this.getPageParam('bs4colexpnd')) this.bs4ColExpnd = 'zx'+this.getPageParam('bs4colexpnd');     
      this.hidcolhead = this.getPageParam('hidcolhead') || this.props.hidcolhead;


      if (this.isSearchMultiple()) {
        this.selectableCheckbox = true;
        this.selectable = "highlight";
      }

      if (this.isSearchSingle()) {
        this.selectableCheckbox = false;
        this.selectable = 1;
      }

      if (this.tabulator) return;

      //domyslne sortowanie 
      let initialSort = [];
		  if(this.getPageParam('sorter_name')) {
			  initialSort = [{column: this.getPageParam('sorter_name'), dir: (this.getPageParam('sorter_dir') || 'asc').toLowerCase()}];
		  }

      //if (this.getPageParam('grouper_name')) {

      const colDef = this.getColDef();
      //Na stronach typu formularz (noHeight) wysokość nie jest limitowana.
      const tabulatorHeight = props.noHeight ? {minHeight: 30} : {height: this.props.bs4flexframe ? 'auto' : '100%'}
      //const tabulatorHeight = props.noHeight ? {} : {height: this.props.bs4flexframe ? 'auto' : '100%'}

      const paginationSize = this.isSimple() ? 9999 : parseInt(this.props.limitRows) || this.getPageParam('paglim') || 50;
      const config = {
        reactiveData: true, //enable data reactivity     
        //height: this.props.bs4flexframe ? 'auto' : '100%', //height: '100%',
        ...tabulatorHeight,
        // 1 512 – Nieprawidłowe wyświetlanie zestawień przy skalowaniu strony [Core]
        renderVertical : 'basic',
        //autoResize: true,
        headerVisible: !Boolean(this.hidcolhead),
        columns: this.getColumns(colDef), //define table columns       
        columnCalcs: 'both',
        movableRows: this.getPageParam('allowdragdrop'),
        rowFormatter: this.rowFormatter,
        groupHeader: this.groupHeader,
        //footerElement: this.footerElement(),
        paginationElement: refPaginationElement.current,
        locale:"pl-PL",
        //locale:true,
        langs: this.tabulatorLangs,
        movableColumns: true,
        pagination: true,
        paginationSize: paginationSize, //this.isSimple() ? 9999 : this.getPageParam('paglim') || 50,
        paginationCounter:"rows",
        paginationMode: "remote",
        sortMode: "remote",
        initialSort: initialSort,
        headerSortElement: this.headerSortElement,
        // selectable: this.selectable,  //5.2.x
        selectableRows: this.selectable,
        //layout: "fitDataFill", //"fitDataFill",
        //layout:  this.autobs4width ? 'fitColumns' : "fitData",  // "fitDataStretch",
        layout: this.autobs4width ? colDef?.length === 1 ? "fitDataStretch" : 'fitColumns' : "fitData",
        //resizableRows : true,
        groupBy: this.getPageParam('grouper_name'),
        groupToggleElement:"header",
        groupHeader: (value, count, data, group) => {
          //value - the value all members of this group share
          //count - the number of rows in this group
          //data - an array of all the row data objects in this group
          //group - the group component for the group
          //console.log('... groupHeader ...', value, count, group, group.getField(), this.columnsObj[group.getField()])
          //return value + "<span style='color:#d00; margin-left:10px;'>(" + count + " item)</span>";
          const title = this.columnsObj[group.getField()].title;
          return "<span style='color:inherit; margin-left:10px;'>"+title+": </span>"+value+"<span style='color:inherit; margin-left:10px;'>("+count+")</span>";
        },
        //responsiveLayout:"collapse",
        //placeholder:"Awaiting Data, Please Load File",
        ajaxURL: Bs4MainDispatch.getUrlPath('web.php?com=Bs4ReportData'),
        ajaxConfig:"POST", //ajax HTTP request type        
        ajaxParams: this.ajaxParams,
        ajaxURLGenerator: this.ajaxURLGenerator,
        ajaxResponse: this.ajaxResponse,        
      };            
      
      this.tabulator = new Tabulator(refTabulator.current, config);
      setTabulator(this.tabulator);        
      
      this.tabulator.on("rowSelectionChanged", (data, rows) => {
        this.rowSelectionChanged(data, rows);
      });

      this.tabulator.on("rowSelected", (row) => {
        this.rowSelected(row);
      });

      this.tabulator.on("rowDeselected", (row) => {
        this.rowDeselected(row);
      });        

      // dataProcessing uruchamia czasem rowSelected, o którym nie należy powiadamiać obserwatorów.
      //The dataProcessing event is triggered after data is loaded into the table, just as it starts being processed into rows and cells.      
      this.tabulator.on("dataProcessing", () => {
        Bs4MainDispatch.speedRun((tag) => {
          console.log(Bs4MainDispatch.speedNextTime(tag), Bs4MainDispatch.speedBs4KarOpt(this.bs4KartotekaId, this.optionId))
        }, '..Type_1 dataProcessing..');
        this.dataProcessing = true;
      });

      //The dataProcessed event is triggered after data has been processed and the table has been rendered.
      this.tabulator.on("dataProcessed", () => {
        Bs4MainDispatch.speedRun((tag) => {
          console.log(Bs4MainDispatch.speedNextTime(tag), Bs4MainDispatch.speedBs4KarOpt(this.bs4KartotekaId, this.optionId))
        }, '..Type_1 dataProcessed..');
        this.shiftOserverEnabled = false;
        this.tabulator?.selectRow(Array.from(this.selesctedRowsId));
        this.shiftOserverEnabled = true;
        this.dataProcessing = false;
      });      

      // this.tabulator.on("cellClick", function(e, cell){
      //   console.log('...cellClick...', cell);
      // });

      this.tabulator.on("rowClick", (e, row) => {                        
        if (row._row.type !== 'row') return;
        if (this.cellEditing) {
          this.cellEditing = null;
          return;
        }
        
        let clickSuccessful = false;
        if (Bs4MainDispatch.commandParserAfter(this.bs4KartotekaId)) {
          clickSuccessful = true;
        } else {
          if (this.rowActiveClick === '1') {
            Bs4MainDispatch.commandParser('Bs4RowClick',{ rowObjectId: row.getData().id, currFormId: this.formId }, this.bs4KartotekaId);
            clickSuccessful = true;
          }
          if (this.rowActiveClick === '2' && !this.targetField?.handleActionsFooterOk) {
            Bs4MainDispatch.commandParser('Bs4RowClick',{ rowObjectId: row.getData().id, currFormId: this.formId }, this.bs4KartotekaId);
            clickSuccessful = true;
          }
        }
        if (clickSuccessful) {
          const id = row.getData().id;
          Bs4MainDispatch.lastCommandParserAfterRow = {
            id: id,
            row: row,
            select: () => {
              this.lastCommandParserAfterRow = id;
              this.tabulator?.getRow(id)?.update({});
            },
            deSelect: () => {
              delete this.lastCommandParserAfterRow;
              this.tabulator?.getRow(id)?.update({});
              this.reload();
            },
          };
        }
      });

      this.tabulator.on("cellEditing", (cell) => {
        // console.log('...cellEditing...', cell);
        this.cellEditing = cell;
      });

      this.tabulator.on("cellEditCancelled", (cell) => {
        // console.log('...cellEditCancelled...', cell);
        this.cellEditing = null;
      });

      this.tabulator.on("cellEdited", (cell) => {
        // console.log('...cellEdited...', cell);
        this.cellEditing = null;
        const row = cell.getRow();
        const index = row.getIndex();
        const cells = row.getCells();
        const data = row.getData();
        this.rowEdited(data.id, data);
        cells.forEach(cell => {                
          const field = cell.getField();
          const column = cell.getColumn()
          const definition = column.getDefinition();
          if (definition?.mutator) {
            this.tabulator.updateData([{id: index, [field]: cell.getValue()}]);
            this.tabulator.recalc();
          }                    
        })        
      });
      
      this.tabulator.on("rowMoved", (row) => {        
        this.rowMoved(row)
      });     

      this.tabulator.on("tableBuilt", () => {
        Bs4MainDispatch.speedRun((tag) =>  {
          console.log(Bs4MainDispatch.speedNextTime(tag), Bs4MainDispatch.speedBs4KarOpt(this.bs4KartotekaId, this.optionId))
        }, '..Type_1 tableBuilt..');
        this.tableBuilt = true;
        if (this.targetField?.query.startsWith('search_')) {
          this.targetField.onChange = (field, oldValue, newValue) => {
            //console.log('...targetField.CHANGE..', newValue)
            this.fieldOserverEnabled = false;
            this.shiftOserverEnabled = false;
            this.clearSelected();
            if (!newValue) newValue = [];
            if (!Array.isArray(newValue)) newValue = [newValue];
            this.selesctedRowsId = new Set(newValue.map(record => record.id));            
            this.tabulator.selectRow(Array.from(this.selesctedRowsId));
            this.shiftOserverEnabled = true;
            this.fieldOserverEnabled = true;
          };
          this.targetField.newField.on(Bs4GenericField.CHANGE, this.targetField.onChange);
          this.targetField.onChange(this.targetField.newField, null, this.targetField.field.getValue());
        }

        this.autoGridReloadEvery();
        this.triggerTabulatorBuilt(true);
      });

      this.on(Bs4ReportType1.BS4_PAGE_PROPS_CHANGE, (bs4PageProps) => {
        // console.log('...BS4_PAGE_PROPS_CHANGE..Type 1.', bs4PageProps);
        setBs4PageProps(bs4PageProps);
      })

      return () => {
        this.tabulator = null;
      }                  
    }, []);

    Bs4MainDispatch.speedRun((tag) => {
      const newObj = {  
        bs4PageProps,
        dateTimeStamp,
        boxSx,
        tabulator,
      };
      console.log(Bs4MainDispatch.speedNextTime(tag), Bs4MainDispatch.speedBs4KarOpt(this.bs4KartotekaId, this.optionId), shallowEqual(newObj, refSpeedTest.current.shallowEqualValues, Bs4MainDispatch.speedPrefix+tag+' EqualValues'), shallowEqual(props, refSpeedTest.current.shallowEqualProps, Bs4MainDispatch.speedPrefix+tag+' EqualProps'));
      refSpeedTest.current.shallowEqualValues = newObj;
      refSpeedTest.current.shallowEqualProps = props;
    }, '..Type_1 View..');

    return (
      <Box ref={ref}
        // className="cssjss-advanced-global-root"
        //Na stronach typu formularz (noHeight) wysokość nie jest limitowana.
        {...(props.noHeight ? {} : {height:'100%'})}
        width='100%' 
        display={'flex'} flexDirection="column"
        overflow='hidden'
        px={props.uxKartoteka?.spacing}
      >
        <report.ViewSelectorField/>
        <HideOnScroll debug='Type1-1-' type={report.optionId}>
          <Box 
            display={report.isSimple() ? 'none' : "flex"}
            flexDirection="row" 
            flexWrap='wrap' 
            gap='6px' 
            //p={0.5}
            alignItems='center' 
          >
            <Bs4Criteria {...report.props}/>
            <report.ViewColumns/>
            <report.ReportBs4HorizontalMenu/>
          </Box>
        </HideOnScroll>
        <Box pt={props.uxKartoteka?.spacing / 3}/>
        <Bs4CriteriaSummary {...report.props} hidden={report.isSimple()}/>
        <div ref={refPaginationElement} style={{display: 'none'}}/>
        <Box 
          overflow='hidden'
          sx={{
            ...boxSx,
            ...(bs4PageProps.lastRow === 0 ? {
              height: 0,
              minHeight: 0,
              margin: 0,
              borderWidth: 0,
            } : {flex: 1})}}
          >        
          <Box             
            ref={refTabulator}            
            height={'100%'}
            onKeyDown={(event) => this.keyDown = event.key}
            onKeyUp={(event) => this.keyDown = null}            
          />                    
        </Box>        
        <HideOnScroll reverse direction='up' debug='Type1-2-' type={report.optionId}>
          <report.ViewBs4Footer smallScreen={smallScreen}/>
        </HideOnScroll>
        <report.ViewSelectorActionsFooter/>
      </Box>
    )
  }));
}